module.exports = __webpack_public_path__ + "assets/images/boundaries/comparison/2020/mobile.svg?v=cc248751";